import React from 'react';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';

export interface PhoneInputContainerProps {
  children: React.ReactNode;
  className?: string;
}

const ContainerComponent: React.FC<PhoneInputContainerProps> = ({
  children,
  className,
}) => {
  return <div className={clsx('peptalk-phone-input', className)}>{children}</div>;
};

export const Container: React.FC<PhoneInputContainerProps> = (
  props: PhoneInputContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'PhoneInputContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};


